import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { FiCalendar } from "react-icons/fi";

const AddHolidayModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      
      {/* HEADER */}
      <div
        style={{
          padding: "16px 20px",
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 600,
          fontSize: "18px",
        }}
      >
        Add Holiday

        <div
          onClick={handleClose}
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            background: "#6b7280",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <IoClose size={16} />
        </div>
      </div>

      {/* BODY */}
      <div style={{ padding: "20px" }}>
        <Form>
          
          {/* Title */}
          <Form.Group style={{ marginBottom: "16px" }}>
            <Form.Label>Title</Form.Label>
            <Form.Control style={{ height: "42px" }} />
          </Form.Group>

          {/* Date */}
          <Form.Group style={{ marginBottom: "16px", position: "relative" }}>
            <Form.Label>Date</Form.Label>
            <Form.Control placeholder="dd/mm/yyyy" style={{ height: "42px" }} />
            
            <FiCalendar
              style={{
                position: "absolute",
                right: "10px",
                top: "38px",
                color: "#6b7280",
              }}
            />
          </Form.Group>

          {/* Description */}
          <Form.Group style={{ marginBottom: "16px" }}>
            <Form.Label>Description</Form.Label>
            <Form.Control as="textarea" rows={4} />
          </Form.Group>

          {/* Status */}
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select style={{ height: "42px" }}>
              <option>Active</option>
              <option>Inactive</option>
            </Form.Select>
          </Form.Group>

        </Form>
      </div>

      {/* FOOTER */}
      <div
        style={{
          borderTop: "1px solid #e5e7eb",
          padding: "14px 20px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <Button
          onClick={handleClose}
          style={{
            background: "#f3f4f6",
            border: "1px solid #e5e7eb",
            color: "#111827",
          }}
        >
          Cancel
        </Button>

        <Button
          style={{
            background: "#f97316",
            border: "none",
          }}
        >
          Add Holiday
        </Button>
      </div>
    </Modal>
  );
};

export default AddHolidayModal;